import gql from "graphql-tag";

export const GET_FILTER = gql`
    query Filter($filterId: ID!){
        filter(filterId: $filterId) {
            filterId
            userId
            filterType
            filterName
            filterDescription
            filterJSON
            filterSQL
            createdAt
            updatedAt
        }
    }
`;

export const GET_FILTERS = gql`
    query Filters($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        filters(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            filterId
            userId
            filterType
            filterName
            filterDescription
            filterJSON
            filterSQL
            createdAt
            updatedAt
        }
    }
`;

export const GET_FILTERS_OF_TYPE = gql`
    query FiltersOfType($filterType: String!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        filtersOfType(filterType: $filterType, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            filterId
            userId
            filterType
            filterName
            filterDescription
            filterJSON
            filterSQL
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_FILTER = gql`
    mutation CreateFilter($newFilter: newFilter!) {
        createFilter(
            newFilter: $newFilter
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_FILTER = gql`
    mutation UpdateFilter($changedFilter: changedFilter!) {
        updateFilter(
            changedFilter: $changedFilter
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_FILTER = gql`
    mutation DeleteFilter($deleteFilterId: ID!) {
        deleteFilter(
            deleteFilterId: $deleteFilterId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_FILTERS = gql`
    mutation DeleteFilters($deleteFilterIds: [ID!]!) {
        deleteFilters(
            deleteFilterIds: $deleteFilterIds
        ) {
            returnCode
            message
        }
    }
`;
